"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEntityIncludedInActionDetails = exports.canAccessEntity = void 0;
const types_1 = require("../types");
const optimetriksRoles_1 = require("./optimetriksRoles");
const canAccessEntity = (id, action, profile) => {
    var _a, _b;
    return !profile ||
        (!!profile && (0, optimetriksRoles_1.isOptimetriksRole)(profile === null || profile === void 0 ? void 0 : profile.name)) ||
        !!profile && !!(profile === null || profile === void 0 ? void 0 : profile.actions) // TODO: should be cannot access entity if no explicit permissions?
            && !!(profile === null || profile === void 0 ? void 0 : profile.actions[action])
            && (0, exports.isEntityIncludedInActionDetails)(id, (_b = (_a = profile === null || profile === void 0 ? void 0 : profile.action_details) === null || _a === void 0 ? void 0 : _a[action]) !== null && _b !== void 0 ? _b : undefined);
};
exports.canAccessEntity = canAccessEntity;
const isEntityIncludedInActionDetails = (entityId, actionDetails) => {
    if (!actionDetails)
        return true;
    switch (actionDetails.include_type) {
        case types_1.ACTION_INCLUDE_TYPE.INCLUDE_ALL_OBJECTS:
            return true;
        case types_1.ACTION_INCLUDE_TYPE.INCLUDE_ALL_OBJECTS_EXCEPT:
            if (actionDetails.ids_to_include_except) {
                return !actionDetails.ids_to_include_except.includes(entityId);
            }
            return true;
        case types_1.ACTION_INCLUDE_TYPE.EXCLUDE_ALL_OBJECTS_EXCEPT:
            if (actionDetails.ids_to_exclude_except) {
                return actionDetails.ids_to_exclude_except.includes(entityId);
            }
            return true;
        default:
            return true;
    }
};
exports.isEntityIncludedInActionDetails = isEntityIncludedInActionDetails;
